import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IAzureSearchFacet } from "@/shared/services/azure-search-service";
import { SearchResult } from "./search-result-model";


export class SearchResponse {
    constructor(
        public results: SearchResult[],
        public count: number,
        public filters: IDictionary<IAzureSearchFacet[]>
    ) { }
}
